// src/database.js
import { db } from "./firebase";
import {
  collection,
  addDoc,
  updateDoc,
  doc,
  increment,
  getDocs,
  query,
  orderBy,
  limit,
  setDoc,
  getDoc,
  where,
  arrayUnion,
  arrayRemove,
  deleteDoc,
} from "firebase/firestore";

// --- 1. KULLANICIYI KAYDET / GÜNCELLE ---
export const syncUserToDB = async (user, customUsername = null) => {
  if (!user) {
    console.log("❌ syncUserToDB: User objesi yok");
    return;
  }

  try {
    console.log("🔄 syncUserToDB başladı. Email:", user.email);
    console.log("📥 Gelen özel kullanıcı adı (customUsername):", customUsername);

    const userRef = doc(db, "users", user.uid);
    const userSnap = await getDoc(userRef);

    let usernameToSave = "";

    if (customUsername && customUsername.trim() !== "") {
      usernameToSave = customUsername;
      console.log("✅ Inputtan gelen kullanıcı adı seçildi:", usernameToSave);
    } else if (user.displayName) {
      usernameToSave = user.displayName;
      console.log("ℹ️ Firebase DisplayName seçildi:", usernameToSave);
    } else {
      usernameToSave = user.email.split('@')[0];
      console.log("⚠️ E-posta ön eki seçildi (fallback):", usernameToSave);
    }

    usernameToSave = usernameToSave.toLowerCase();

    if (!userSnap.exists()) {
      console.log("➕ Yeni kullanıcı oluşturuluyor, isim:", usernameToSave);

      await setDoc(userRef, {
        email: user.email,
        username: usernameToSave,
        totalLikes: 0,
        totalTracks: 0,
        totalPlays: 0,
        totalFavorites: 0, // 🆕 Yeni eklenen alan
        likedTracks: [],
        favoriteTracks: [], // 🆕 Yeni eklenen alan
        createdAt: new Date(),
        uid: user.uid,
        level: 1,
        exp: 0,
        currentStreak: 0,
        longestStreak: 0,
        learningLevel: "Beginner"
      });
      console.log("✅ Kullanıcı veritabanına kaydedildi! ->", usernameToSave);

    } else {
      console.log("✅ Kullanıcı zaten mevcut.");

      const userData = userSnap.data();

      // Yeni alanlar yoksa ekle
      const updates = {};

      if (!userData.likedTracks) {
        updates.likedTracks = [];
      }
      if (userData.totalPlays === undefined) {
        updates.totalPlays = 0;
      }
      // --- FAVORİ GÜNCELLEMELERİ ---
      if (!userData.favoriteTracks) {
        updates.favoriteTracks = [];
      }
      if (userData.totalFavorites === undefined) {
        updates.totalFavorites = 0;
      }
      // -----------------------------

      if (!userData.level) {
        updates.level = 1;
      }
      if (!userData.exp) {
        updates.exp = 0;
      }
      if (!userData.currentStreak) {
        updates.currentStreak = 0;
      }
      if (!userData.longestStreak) {
        updates.longestStreak = 0;
      }
      if (!userData.learningLevel) {
        updates.learningLevel = "Beginner";
      }

      if (customUsername || !userData.username) {
        updates.username = usernameToSave;
        console.log("♻️ Kullanıcı adı veritabanında güncellendi ->", usernameToSave);
      }

      // Eğer güncellenecek bir şey varsa güncelle
      if (Object.keys(updates).length > 0) {
        await updateDoc(userRef, updates);
      }
    }
  } catch (error) {
    console.error("❌ syncUserToDB hatası:", error.code, error.message);
    throw error;
  }
};

// --- 2. KULLANICI ADI KONTROLÜ (Benzersiz mi?) ---
export const isUsernameAvailable = async (username) => {
  try {
    if (!username) return false;

    console.log("🔍 Kullanıcı adı kontrolü:", username.toLowerCase());
    const usersRef = collection(db, "users");
    const q = query(usersRef, where("username", "==", username.toLowerCase()));
    const snapshot = await getDocs(q);

    return snapshot.empty;
  } catch (error) {
    console.error("❌ Kullanıcı adı kontrolü hatası:", error);
    return false;
  }
};

// --- 3. KULLANICI ADI İLE E-POSTA BULMA ---
export const getEmailByUsername = async (username) => {
  try {
    if (!username) return null;

    const usersRef = collection(db, "users");
    const q = query(usersRef, where("username", "==", username.toLowerCase()));
    const snapshot = await getDocs(q);

    if (!snapshot.empty) {
      const userData = snapshot.docs[0].data();
      return userData.email;
    }

    return null;
  } catch (error) {
    console.error("❌ E-posta bulma hatası:", error);
    return null;
  }
};

// --- 4. ŞARKI KAYDETME (GÜNCELLENMİŞ) ---
export const saveTrackToDB = async (userId, trackTitle, trackCode, isPublic = true) => {
  try {
    console.log("💾 Şarkı kaydediliyor...");

    // Aynı kullanıcının aynı isimli başka bir track'i var mı kontrol et
    const tracksRef = collection(db, "tracks");
    const q = query(
      tracksRef,
      where("uid", "==", userId),
      where("title", "==", trackTitle)
    );
    const existingTracks = await getDocs(q);

    if (!existingTracks.empty) {
      console.error("❌ Bu isimde bir parçanız zaten var!");
      throw new Error("DUPLICATE_TITLE");
    }

    const docRef = await addDoc(collection(db, "tracks"), {
      uid: userId,
      title: trackTitle,
      code: trackCode,
      isPublic: isPublic,
      likes: 0,
      plays: 0,
      favorites: 0, // Yeni trackler için favori sayacı
      createdAt: new Date()
    });

    const userRef = doc(db, "users", userId);
    await updateDoc(userRef, {
      totalTracks: increment(1)
    });

    console.log("✅ Şarkı kaydedildi! ID:", docRef.id);
    return { success: true, trackId: docRef.id };
  } catch (error) {
    console.error("❌ Şarkı kaydetme hatası:", error);
    throw error;
  }
};

// --- 5. ŞARKI BEĞENME (YENİ VERSİYON) ---
export const likeTrack = async (trackId, currentUserId) => {
  try {
    console.log("❤️ Beğeni işlemi başlıyor...");

    // Track bilgilerini al
    const trackRef = doc(db, "tracks", trackId);
    const trackSnap = await getDoc(trackRef);

    if (!trackSnap.exists()) {
      console.error("❌ Track bulunamadı!");
      return false;
    }

    const trackData = trackSnap.data();
    const ownerId = trackData.uid;

    // Kullanıcının beğendiği parçalar listesini al
    const userRef = doc(db, "users", currentUserId);
    const userSnap = await getDoc(userRef);
    const userData = userSnap.data();
    const likedTracks = userData.likedTracks || [];

    // Eğer zaten beğenmişse, beğeniyi kaldır
    if (likedTracks.includes(trackId)) {
      console.log("💔 Beğeni kaldırılıyor...");

      // Kullanıcının likedTracks listesinden çıkar
      await updateDoc(userRef, {
        likedTracks: arrayRemove(trackId)
      });

      // Track'in like sayısını azalt
      await updateDoc(trackRef, {
        likes: increment(-1)
      });

      // Track sahibinin totalLikes'ını azalt
      if (ownerId !== currentUserId) {
        const ownerRef = doc(db, "users", ownerId);
        await updateDoc(ownerRef, {
          totalLikes: increment(-1)
        });
      }

      console.log("✅ Beğeni kaldırıldı!");
      return false; // Unlike yapıldı

    } else {
      console.log("❤️ Beğeni ekleniyor...");

      // Kullanıcının likedTracks listesine ekle
      await updateDoc(userRef, {
        likedTracks: arrayUnion(trackId)
      });

      // Track'in like sayısını artır
      await updateDoc(trackRef, {
        likes: increment(1)
      });

      // Track sahibinin totalLikes'ını artır (kendi şarkısını beğenmiyorsa)
      if (ownerId !== currentUserId) {
        const ownerRef = doc(db, "users", ownerId);
        await updateDoc(ownerRef, {
          totalLikes: increment(1)
        });
      }

      console.log("✅ Beğeni eklendi!");
      return true; // Like yapıldı
    }

  } catch (error) {
    console.error("❌ Beğeni hatası:", error);
    return null;
  }
};


// --- 6. BEĞENİLEN PARCALARI GETIR (DÜZELTİLDİ) ---
export const getLikedTracks = async (userId) => {
  try {
    console.log("🔍 Beğenilen parçalar getiriliyor...");

    if (!userId) {
      console.log("❌ User ID yok");
      return [];
    }

    const userRef = doc(db, "users", userId);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
      console.log("❌ Kullanıcı bulunamadı");
      return [];
    }

    const userData = userSnap.data();
    const likedTrackIds = userData?.likedTracks || [];

    // Array olduğundan emin ol
    if (!Array.isArray(likedTrackIds) || likedTrackIds.length === 0) {
      console.log("ℹ️ Beğenilen parça yok");
      return [];
    }

    console.log("📋 Beğenilen track ID'leri:", likedTrackIds);

    // Her track ID için track bilgilerini çek
    const tracksPromises = likedTrackIds
      .filter(trackId => trackId && typeof trackId === 'string') // Geçerli ID kontrolü
      .map(async (trackId) => {
        try {
          const trackRef = doc(db, "tracks", trackId);
          const trackSnap = await getDoc(trackRef);

          if (!trackSnap.exists()) {
            console.warn(`⚠️ Track bulunamadı: ${trackId}`);
            return null;
          }

          const trackData = trackSnap.data();

          if (!trackData || !trackData.uid) {
            console.warn(`⚠️ Track data eksik: ${trackId}`);
            return null;
          }

          // Track sahibinin username'ini al
          let ownerUsername = "Unknown";
          try {
            const ownerRef = doc(db, "users", trackData.uid);
            const ownerSnap = await getDoc(ownerRef);

            if (ownerSnap.exists()) {
              const ownerData = ownerSnap.data();
              // Daha güvenli email parse
              const emailPrefix = ownerData?.email ? String(ownerData.email).split('@')[0] : "Unknown";
              ownerUsername = ownerData?.username || emailPrefix;
            }
          } catch (ownerError) {
            console.warn(`⚠️ Owner bilgisi alınamadı: ${trackData.uid}`);
          }

          return {
            id: trackSnap.id,
            ...trackData,
            ownerUsername
          };
        } catch (trackError) {
          console.error(`❌ Track getirme hatası: ${trackId}`, trackError);
          return null;
        }
      });

    const tracks = await Promise.all(tracksPromises);
    const validTracks = tracks.filter(track =>
      track !== null &&
      track !== undefined &&
      track.id &&
      track.title
    );

    console.log("✅ Beğenilen parçalar getirildi:", validTracks.length, "adet");
    return validTracks;

  } catch (error) {
    console.error("❌ Beğenilen parçaları getirme hatası:", error);
    return [];
  }
};

// --- 7. TRACK'İN BEĞENİLİP BEĞENİLMEDİĞİNİ KONTROL ET (YENİ) ---
export const isTrackLiked = async (trackId, userId) => {
  try {
    const userRef = doc(db, "users", userId);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) return false;

    const userData = userSnap.data();
    const likedTracks = userData.likedTracks || [];

    return likedTracks.includes(trackId);

  } catch (error) {
    console.error("❌ Beğeni kontrolü hatası:", error);
    return false;
  }
};

// --- 8. LEADERBOARD (SIRALAMA) ÇEKME ---
export const getLeaderboard = async () => {
  try {
    const usersRef = collection(db, "users");
    const q = query(usersRef, orderBy("totalLikes", "desc"), limit(10));

    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc, index) => ({
      id: doc.id,
      rank: index + 1,
      ...doc.data()
    }));
  } catch (error) {
    console.error("❌ Leaderboard hatası:", error);
    return [];
  }
};

// --- 9. KULLANICININ ŞARKILARINI ÇEKME ---
export const getUserTracks = async (userId) => {
  try {
    const tracksRef = collection(db, "tracks");
    const q = query(tracksRef, orderBy("createdAt", "desc"));

    const snapshot = await getDocs(q);
    return snapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(data => data.uid === userId);
  } catch (error) {
    console.error("❌ Şarkı çekme hatası:", error);
    return [];
  }
};

// --- 10. KEŞFET (EXPLORER) PARÇALARINI GETİR ---
export const getExplorerTracks = async (filterType = "newest") => {
  try {
    console.log(`🌍 Keşfet yükleniyor... Filtre: ${filterType}`);

    const tracksRef = collection(db, "tracks");
    let q;

    switch (filterType) {
      case "mostLiked":
        q = query(
          tracksRef,
          where("isPublic", "==", true),
          orderBy("likes", "desc"),
          limit(50)
        );
        break;

      case "mostPlayed":
        q = query(
          tracksRef,
          where("isPublic", "==", true),
          orderBy("plays", "desc"),
          limit(50)
        );
        break;

      case "newest":
      default:
        q = query(
          tracksRef,
          where("isPublic", "==", true),
          orderBy("createdAt", "desc"),
          limit(50)
        );
        break;
    }

    const snapshot = await getDocs(q);

    // Her track için kullanıcı adını da çekiyoruz
    const tracksPromises = snapshot.docs.map(async (docSnap) => {
      const trackData = docSnap.data();

      let ownerUsername = "Unknown";
      try {
        const ownerRef = doc(db, "users", trackData.uid);
        const ownerSnap = await getDoc(ownerRef);
        if (ownerSnap.exists()) {
          ownerUsername = ownerSnap.data().username;
        }
      } catch (err) {
        console.warn("Kullanıcı bilgisi çekilemedi:", err);
      }

      return {
        id: docSnap.id,
        ...trackData,
        ownerUsername
      };
    });

    const results = await Promise.all(tracksPromises);
    console.log(`✅ Keşfet verileri geldi (${filterType}):`, results.length, "adet");
    return results;

  } catch (error) {
    console.error("❌ Keşfet verileri getirme hatası:", error);
    if (error.message.includes("requires an index")) {
      console.error("⚠️ LÜTFEN FIREBASE KONSOLUNDAN INDEX OLUŞTURUN (Link yukarıdaki hata mesajında var)");
    }
    return [];
  }
};

// --- 11. KULLANICI PROFİL BİLGİLERİNİ ÇEKME ---
export const getUserProfile = async (userId) => {
  try {
    const userRef = doc(db, "users", userId);
    const userSnap = await getDoc(userRef);
    return userSnap.exists() ? userSnap.data() : null;
  } catch (error) {
    console.error("❌ Profil çekme hatası:", error);
    return null;
  }
};

// --- 12. ŞARKI OYNATMA (Play Count Artırma) ---
export const incrementTrackPlays = async (trackId, userId) => {
  try {
    console.log("▶️ Play count artırılıyor...", { trackId, userId });

    if (!userId) {
      console.log("ℹ️ Anonim kullanıcı, play count artırılmıyor.");
      return false;
    }

    const userRef = doc(db, "users", userId);
    const playHistoryRef = doc(userRef, "playHistory", trackId);

    // Son dinleme zamanını kontrol et
    const historySnap = await getDoc(playHistoryRef);
    const now = new Date();
    const cooldownMs = 30 * 60 * 1000; // 30 dakika

    if (historySnap.exists()) {
      const lastPlayed = historySnap.data().lastPlayed?.toDate();
      if (lastPlayed && (now - lastPlayed) < cooldownMs) {
        console.log("⏳ Play count throttled (30 dk kuralı)");
        return false;
      }
    }

    // Play history güncelle
    await setDoc(playHistoryRef, {
      lastPlayed: now,
      trackId: trackId
    });

    const trackRef = doc(db, "tracks", trackId);
    const trackSnap = await getDoc(trackRef);

    if (!trackSnap.exists()) {
      console.error("❌ Track bulunamadı!");
      return false;
    }

    const trackData = trackSnap.data();
    const ownerId = trackData.uid;

    // Track'in play sayısını artır
    await updateDoc(trackRef, {
      plays: increment(1),
      lastPlayedAt: now
    });

    // Track sahibinin totalPlays'ini artır
    const ownerRef = doc(db, "users", ownerId);
    await updateDoc(ownerRef, {
      totalPlays: increment(1)
    });

    console.log("✅ Play count artırıldı!");
    return true;

  } catch (error) {
    console.error("❌ Play count artırma hatası:", error);
    return false;
  }
};

// --- 13. LEADERBOARD (Dinlenme Sayısına Göre) ---
export const getLeaderboardByPlays = async (timeRange = "weekly") => {
  try {
    console.log("🏆 Leaderboard yükleniyor:", timeRange);

    const now = new Date();
    let startDate;

    switch (timeRange) {
      case "weekly":
        startDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
        break;
      case "monthly":
        startDate = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
        break;
      case "yearly":
        startDate = new Date(now.getTime() - 365 * 24 * 60 * 60 * 1000);
        break;
      default:
        startDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
    }

    const tracksRef = collection(db, "tracks");
    const q = query(
      tracksRef,
      where("createdAt", ">=", startDate),
      where("isPublic", "==", true)
    );

    const snapshot = await getDocs(q);

    const userPlaysMap = {};

    snapshot.docs.forEach(doc => {
      const trackData = doc.data();
      const uid = trackData.uid;
      const plays = trackData.plays || 0;

      if (!userPlaysMap[uid]) {
        userPlaysMap[uid] = {
          uid,
          totalPlays: 0,
          trackCount: 0
        };
      }

      userPlaysMap[uid].totalPlays += plays;
      userPlaysMap[uid].trackCount += 1;
    });

    const usersPromises = Object.keys(userPlaysMap).map(async (uid) => {
      const userRef = doc(db, "users", uid);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        const userData = userSnap.data();
        return {
          ...userPlaysMap[uid],
          username: userData.username,
          totalLikes: userData.totalLikes || 0,
          totalTracks: userData.totalTracks || 0,
          level: userData.level || 1
        };
      }
      return null;
    });

    const users = await Promise.all(usersPromises);
    const validUsers = users.filter(user => user !== null);

    validUsers.sort((a, b) => b.totalPlays - a.totalPlays);

    const topUsers = validUsers.slice(0, 50);

    console.log("✅ Leaderboard hazır:", topUsers.length, "kullanıcı");
    return topUsers;

  } catch (error) {
    console.error("❌ Leaderboard hatası:", error);
    return [];
  }
};

// --- 14. KULLANICI İSTATİSTİKLERİNİ GÜNCELLE ---
export const updateUserStats = async (userId) => {
  try {
    console.log("📊 Kullanıcı istatistikleri güncelleniyor...");

    const tracksRef = collection(db, "tracks");
    const q = query(tracksRef, where("uid", "==", userId));
    const snapshot = await getDocs(q);

    let totalPlays = 0;
    let totalLikes = 0;
    let totalTracks = snapshot.size;

    snapshot.docs.forEach(doc => {
      const trackData = doc.data();
      totalPlays += trackData.plays || 0;
      totalLikes += trackData.likes || 0;
    });

    const userRef = doc(db, "users", userId);
    await updateDoc(userRef, {
      totalPlays,
      totalLikes,
      totalTracks,
      lastStatsUpdate: new Date()
    });

    console.log("✅ Kullanıcı istatistikleri güncellendi!");
    return true;

  } catch (error) {
    console.error("❌ İstatistik güncelleme hatası:", error);
    return false;
  }
};

// --- 15. TÜM KULLANICLARIN İSTATİSTİKLERİNİ GÜNCELLE ---
export const updateAllUsersStats = async () => {
  try {
    console.log("🔄 Tüm kullanıcıların istatistikleri güncelleniyor...");

    const usersRef = collection(db, "users");
    const snapshot = await getDocs(usersRef);

    const updatePromises = snapshot.docs.map(doc =>
      updateUserStats(doc.id)
    );

    await Promise.all(updatePromises);

    console.log("✅ Tüm kullanıcılar güncellendi!");
    return true;

  } catch (error) {
    console.error("❌ Toplu güncelleme hatası:", error);
    return false;
  }
};

// --- TRACK GÜNCELLEME ---
export const updateTrackInDB = async (trackId, newCode, newTitle, isPublic) => {
  try {
    console.log("🔄 Track güncelleniyor:", trackId);


    const trackRef = doc(db, "tracks", trackId);
    const trackSnap = await getDoc(trackRef);

    if (!trackSnap.exists()) {
      console.error("❌ Track bulunamadı!");
      return false;
    }
    const trackData = trackSnap.data();

    // Eğer track public ise güncellemeyi engelle
    if (trackData.isPublic === true && isPublic === true) {
      console.error("❌ Published tracks cannot be modified!");
      return false;
    }

    const updateData = {
      code: newCode,
      title: newTitle,
      updatedAt: new Date()
    };

    // isPublic parametresi undefined değilse güncelle
    if (isPublic !== undefined) {
      updateData.isPublic = isPublic;
    }
    // Sadece private track'ler güncellenebilir
    await updateDoc(trackRef, updateData);

    console.log("✅ Track güncellendi!");
    return true;
  } catch (error) {
    console.error("❌ Track güncelleme hatası:", error);
    return false;
  }
};

// --- TRACK SİLME ---
export const deleteTrackFromDB = async (trackId, userId) => {
  try {
    console.log("🗑️ Track siliniyor:", trackId);

    const trackRef = doc(db, "tracks", trackId);
    await deleteDoc(trackRef);

    const userRef = doc(db, "users", userId);
    await updateDoc(userRef, {
      totalTracks: increment(-1)
    });

    console.log("✅ Track silindi!");
    return true;
  } catch (error) {
    console.error("❌ Track silme hatası:", error);
    return false;
  }
};

// --- YENİ EKLENEN FAVORİ FONKSİYONLARI ---

// --- 16. FAVORİ EKLE/ÇIKAR ---
export const toggleFavorite = async (trackId, currentUserId) => {
  try {
    console.log("⭐ Favori işlemi başlıyor...");

    // Track bilgilerini al
    const trackRef = doc(db, "tracks", trackId);
    const trackSnap = await getDoc(trackRef);

    if (!trackSnap.exists()) {
      console.error("❌ Track bulunamadı!");
      return false;
    }

    const trackData = trackSnap.data();
    const ownerId = trackData.uid;

    // Kullanıcının favori listesini al
    const userRef = doc(db, "users", currentUserId);
    const userSnap = await getDoc(userRef);
    const userData = userSnap.data();
    const favoriteTracks = userData.favoriteTracks || [];

    // Eğer zaten favorilerdeyse, çıkar
    if (favoriteTracks.includes(trackId)) {
      console.log("💔 Favorilerden kaldırılıyor...");

      // Kullanıcının favoriteTracks listesinden çıkar
      await updateDoc(userRef, {
        favoriteTracks: arrayRemove(trackId)
      });

      // Track'in favorites sayısını azalt
      await updateDoc(trackRef, {
        favorites: increment(-1)
      });

      // Track sahibinin totalFavorites'ını azalt
      if (ownerId !== currentUserId) {
        const ownerRef = doc(db, "users", ownerId);
        await updateDoc(ownerRef, {
          totalFavorites: increment(-1)
        });
      }

      console.log("✅ Favorilerden kaldırıldı!");
      return false; // Unfavorited

    } else {
      console.log("⭐ Favorilere ekleniyor...");

      // Kullanıcının favoriteTracks listesine ekle
      await updateDoc(userRef, {
        favoriteTracks: arrayUnion(trackId)
      });

      // Track'in favorites sayısını artır
      await updateDoc(trackRef, {
        favorites: increment(1)
      });

      // Track sahibinin totalFavorites'ını artır
      if (ownerId !== currentUserId) {
        const ownerRef = doc(db, "users", ownerId);
        await updateDoc(ownerRef, {
          totalFavorites: increment(1)
        });
      }

      console.log("✅ Favorilere eklendi!");
      return true; // Favorited
    }

  } catch (error) {
    console.error("❌ Favori hatası:", error);
    return null;
  }
};

// --- 17. FAVORİ KONTROLÜ ---
export const isTrackFavorited = async (trackId, userId) => {
  try {
    const userRef = doc(db, "users", userId);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) return false;

    const userData = userSnap.data();
    const favoriteTracks = userData.favoriteTracks || [];

    return favoriteTracks.includes(trackId);

  } catch (error) {
    console.error("❌ Favori kontrolü hatası:", error);
    return false;
  }
};

// --- 18. FAVORİ PARÇALARI GETİR (DÜZELTİLDİ) ---
export const getFavoriteTracks = async (userId) => {
  try {
    console.log("🔍 Favori parçalar getiriliyor...");

    if (!userId) {
      console.log("❌ User ID yok");
      return [];
    }

    const userRef = doc(db, "users", userId);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
      console.log("❌ Kullanıcı bulunamadı");
      return [];
    }

    const userData = userSnap.data();
    const favoriteTrackIds = userData?.favoriteTracks || [];

    // Array olduğundan emin ol
    if (!Array.isArray(favoriteTrackIds) || favoriteTrackIds.length === 0) {
      console.log("ℹ️ Favori parça yok");
      return [];
    }

    console.log("📋 Favori track ID'leri:", favoriteTrackIds);

    // Her track ID için track bilgilerini çek
    const tracksPromises = favoriteTrackIds
      .filter(trackId => trackId && typeof trackId === 'string') // Geçerli ID kontrolü
      .map(async (trackId) => {
        try {
          const trackRef = doc(db, "tracks", trackId);
          const trackSnap = await getDoc(trackRef);

          if (!trackSnap.exists()) {
            console.warn(`⚠️ Track bulunamadı: ${trackId}`);
            return null;
          }

          const trackData = trackSnap.data();

          if (!trackData || !trackData.uid) {
            console.warn(`⚠️ Track data eksik: ${trackId}`);
            return null;
          }

          // Track sahibinin username'ini al
          let ownerUsername = "Unknown";
          try {
            const ownerRef = doc(db, "users", trackData.uid);
            const ownerSnap = await getDoc(ownerRef);

            if (ownerSnap.exists()) {
              const ownerData = ownerSnap.data();
              ownerUsername = ownerData?.username || ownerData?.email?.split('@')[0] || "Unknown";
            }
          } catch (ownerError) {
            console.warn(`⚠️ Owner bilgisi alınamadı: ${trackData.uid}`);
          }

          return {
            id: trackSnap.id,
            ...trackData,
            ownerUsername
          };
        } catch (trackError) {
          console.error(`❌ Track getirme hatası: ${trackId}`, trackError);
          return null;
        }
      });

    const tracks = await Promise.all(tracksPromises);
    const validTracks = tracks.filter(track =>
      track !== null &&
      track !== undefined &&
      track.id &&
      track.title
    );

    console.log("✅ Favori parçalar getirildi:", validTracks.length, "adet");
    return validTracks;

  } catch (error) {
    console.error("❌ Favori parçaları getirme hatası:", error);
    return [];
  }
};

// --- 19. TOP TRACKS (EN ÇOK DİNLENENLER LİSTESİ) ---
export const getTopTracks = async (period = "weekly") => {
  try {
    console.log(`🏆 Top Tracks yükleniyor... Periyot: ${period}`);

    const tracksRef = collection(db, "tracks");
    let q;
    const now = new Date();
    let startDate = null;

    // Periyoda göre başlangıç tarihi belirle
    switch (period) {
      case "weekly":
        // Son 7 gün
        startDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
        break;
      case "monthly":
        // Son 30 gün
        startDate = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
        break;
      case "all_time":
      default:
        // Tarih filtresi yok
        startDate = null;
        break;
    }

    if (startDate) {
      // Belirli bir tarih aralığı varsa (Örn: Bu hafta çıkan ve en çok dinlenenler)
      // NOT: Firebase'de 'createdAt' filtresi ve 'plays' sıralamasını aynı anda kullanmak için
      // konsolda bir "Composite Index" oluşturmanız gerekir. Hata alırsanız linke tıklayın.
      q = query(
        tracksRef,
        where("isPublic", "==", true),
        where("createdAt", ">=", startDate),
        orderBy("plays", "desc"),
        limit(50)
      );
    } else {
      // Tüm zamanların en iyileri
      q = query(
        tracksRef,
        where("isPublic", "==", true),
        orderBy("plays", "desc"),
        limit(50)
      );
    }

    const snapshot = await getDocs(q);

    // Her track için kullanıcı (owner) bilgisini çek (Explorer fonksiyonundaki mantıkla aynı)
    const tracksPromises = snapshot.docs.map(async (docSnap) => {
      const trackData = docSnap.data();
      let ownerUsername = "Unknown";

      try {
        const ownerRef = doc(db, "users", trackData.uid);
        const ownerSnap = await getDoc(ownerRef);
        if (ownerSnap.exists()) {
          ownerUsername = ownerSnap.data().username;
        }
      } catch (err) {
        console.warn(`⚠️ ID: ${trackData.uid} için kullanıcı adı çekilemedi.`);
      }

      return {
        id: docSnap.id,
        ...trackData,
        ownerUsername
      };
    });

    const results = await Promise.all(tracksPromises);

    console.log(`✅ Top Tracks (${period}) getirildi:`, results.length, "adet");
    return results;

  } catch (error) {
    console.error("❌ Top Tracks getirme hatası:", error);

    // İndeks hatası uyarısı (Geliştirici dostu)
    if (error.message.includes("requires an index")) {
      console.error("⚠️ DİKKAT: Bu sorgunun (where: createdAt + orderBy: plays) çalışması için Firebase Index gereklidir.");
      console.error("👉 Hata çıktısındaki linke tıklayarak indeksi otomatik oluşturabilirsiniz.");
    }
    return [];
  }
};

// database.js - YENİ FONKSİYONLAR (Mevcut kodunuzun sonuna ekleyin)

// --- 20. LEADERBOARD (METRİĞE GÖRE) ---
export const getLeaderboardByMetric = async (timeRange = "weekly", metric = "plays") => {
  try {
    console.log(`🏆 Leaderboard yükleniyor... Periyot: ${timeRange}, Metrik: ${metric}`);

    const now = new Date();
    let startDate;

    switch (timeRange) {
      case "weekly":
        startDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
        break;
      case "monthly":
        startDate = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
        break;
      case "yearly":
        startDate = new Date(now.getTime() - 365 * 24 * 60 * 60 * 1000);
        break;
      case "all_time":
        startDate = new Date(0); // Başlangıçtan itibaren
        break;
      default:
        startDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
    }

    const tracksRef = collection(db, "tracks");
    const q = query(
      tracksRef,
      where("createdAt", ">=", startDate),
      where("isPublic", "==", true)
    );

    const snapshot = await getDocs(q);

    // Kullanıcı bazında metrikleri topla
    const userMetricsMap = {};

    snapshot.docs.forEach(doc => {
      const trackData = doc.data();
      const uid = trackData.uid;
      const plays = trackData.plays || 0;
      const likes = trackData.likes || 0;
      const favorites = trackData.favorites || 0;

      if (!userMetricsMap[uid]) {
        userMetricsMap[uid] = {
          uid,
          totalPlays: 0,
          totalLikes: 0,
          totalFavorites: 0,
          trackCount: 0
        };
      }

      userMetricsMap[uid].totalPlays += plays;
      userMetricsMap[uid].totalLikes += likes;
      userMetricsMap[uid].totalFavorites += favorites;
      userMetricsMap[uid].trackCount += 1;
    });

    // Kullanıcı bilgilerini ekle
    const usersPromises = Object.keys(userMetricsMap).map(async (uid) => {
      const userRef = doc(db, "users", uid);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        const userData = userSnap.data();
        return {
          ...userMetricsMap[uid],
          username: userData.username,
          level: userData.level || 1
        };
      }
      return null;
    });

    const users = await Promise.all(usersPromises);
    const validUsers = users.filter(user => user !== null);

    // Seçilen metriğe göre sırala
    validUsers.sort((a, b) => {
      if (metric === "plays") {
        return b.totalPlays - a.totalPlays;
      } else if (metric === "likes") {
        return b.totalLikes - a.totalLikes;
      } else if (metric === "favorites") {
        return b.totalFavorites - a.totalFavorites;
      }
      return 0;
    });

    const topUsers = validUsers.slice(0, 50);

    console.log(`✅ Leaderboard hazır (${metric}):`, topUsers.length, "kullanıcı");
    return topUsers;

  } catch (error) {
    console.error("❌ Leaderboard hatası:", error);
    return [];
  }
};

// --- 21. TOP TRACKS (METRİĞE GÖRE) ---
export const getTopTracksByMetric = async (timeRange = "weekly", metric = "plays") => {
  try {
    console.log(`🎵 Top Tracks yükleniyor... Periyot: ${timeRange}, Metrik: ${metric}`);

    const now = new Date();
    let startDate;

    switch (timeRange) {
      case "weekly":
        startDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
        break;
      case "monthly":
        startDate = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
        break;
      case "yearly":
        startDate = new Date(now.getTime() - 365 * 24 * 60 * 60 * 1000);
        break;
      case "all_time":
        startDate = new Date(0);
        break;
      default:
        startDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
    }

    const tracksRef = collection(db, "tracks");
    const q = query(
      tracksRef,
      where("isPublic", "==", true),
      where("createdAt", ">=", startDate)
    );

    const snapshot = await getDocs(q);

    // Track'leri al ve owner username'ini ekle
    const tracksPromises = snapshot.docs.map(async (docSnap) => {
      const trackData = docSnap.data();
      let ownerUsername = "Unknown";

      try {
        const ownerRef = doc(db, "users", trackData.uid);
        const ownerSnap = await getDoc(ownerRef);
        if (ownerSnap.exists()) {
          ownerUsername = ownerSnap.data().username;
        }
      } catch (err) {
        console.warn(`⚠️ Kullanıcı bilgisi çekilemedi: ${trackData.uid}`);
      }

      return {
        id: docSnap.id,
        ...trackData,
        ownerUsername
      };
    });

    const tracks = await Promise.all(tracksPromises);

    // Seçilen metriğe göre sırala
    tracks.sort((a, b) => {
      if (metric === "plays") {
        return (b.plays || 0) - (a.plays || 0);
      } else if (metric === "likes") {
        return (b.likes || 0) - (a.likes || 0);
      } else if (metric === "favorites") {
        return (b.favorites || 0) - (a.favorites || 0);
      }
      return 0;
    });

    const topTracks = tracks.slice(0, 50);

    console.log(`✅ Top Tracks hazır (${metric}):`, topTracks.length, "track");
    return topTracks;

  } catch (error) {
    console.error("❌ Top Tracks hatası:", error);
    return [];
  }
};

// --- 22. LEARN XP KAZANMA (YENİ) ---
export const awardLearningXP = async (userId, xpAmount) => {
  try {
    console.log(`🎓 XP kazandırılıyor: ${xpAmount} XP`);

    const userRef = doc(db, "users", userId);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
      console.error("❌ Kullanıcı bulunamadı");
      return false;
    }

    const userData = userSnap.data();
    const currentExp = userData.exp || 0;
    const currentLevel = userData.level || 1;

    const newExp = currentExp + xpAmount;
    const xpPerLevel = 1000; // Her seviye için gereken XP
    const newLevel = Math.floor(newExp / xpPerLevel) + 1;

    // XP ve Level güncelle
    await updateDoc(userRef, {
      exp: newExp,
      level: newLevel,
      lastLearningActivity: new Date()
    });

    console.log(`✅ XP kazandırıldı! Yeni XP: ${newExp}, Seviye: ${newLevel}`);

    // Seviye atladıysa bildir
    if (newLevel > currentLevel) {
      console.log(`🎊 LEVEL UP! ${currentLevel} -> ${newLevel}`);
    }

    return {
      newExp,
      newLevel,
      leveledUp: newLevel > currentLevel
    };

  } catch (error) {
    console.error("❌ XP kazandırma hatası:", error);
    return false;
  }
};

// --- 23. LEARN İLERLEMESİNİ KAYDET (GÜNCELLENDİ: XP Dahil) ---
export const saveLearningProgress = async (userId, level, stageIndex, xpGained = 0) => {
  try {
    console.log(`💾 Learn ilerlemesi kaydediliyor: ${level} - Stage ${stageIndex}`);

    const userRef = doc(db, "users", userId);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
      console.error("❌ Kullanıcı bulunamadı");
      return false;
    }

    const userData = userSnap.data();
    const learningProgress = userData.learningProgress || {
      beginner: Array(12).fill(false),
      intermediate: Array(16).fill(false),
      expert: Array(12).fill(false)
    };

    // İlgili stage'i true yap
    learningProgress[level][stageIndex] = true;

    // Progress'i kaydet
    await updateDoc(userRef, {
      learningProgress: learningProgress,
      lastLearningActivity: new Date()
    });

    // XP varsa kazandır
    if (xpGained > 0) {
      await awardLearningXP(userId, xpGained);
    }

    console.log(`✅ Learn ilerlemesi kaydedildi!`);
    return true;

  } catch (error) {
    console.error("❌ Learn ilerleme kaydetme hatası:", error);
    return false;
  }
};

// --- 24. LEARN İLERLEMESİNİ GETİR (YENİ) ---
export const getLearningProgress = async (userId) => {
  try {
    console.log("📖 Learn ilerlemesi getiriliyor...");

    const userRef = doc(db, "users", userId);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
      console.log("❌ Kullanıcı bulunamadı");
      // Varsayılan boş ilerleme döndür
      return {
        beginner: Array(12).fill(false),
        intermediate: Array(16).fill(false),
        expert: Array(12).fill(false)
      };
    }

    const userData = userSnap.data();
    const learningProgress = userData.learningProgress || {
      beginner: Array(12).fill(false),
      intermediate: Array(16).fill(false),
      expert: Array(12).fill(false)
    };

    console.log("✅ Learn ilerlemesi getirildi");
    return learningProgress;

  } catch (error) {
    console.error("❌ Learn ilerleme getirme hatası:", error);
    // Hata durumunda boş ilerleme döndür
    return {
      beginner: Array(12).fill(false),
      intermediate: Array(16).fill(false),
      expert: Array(12).fill(false)
    };
  }
};